import { PrimaryButton } from "components/Button/style";
import { DropdownSelect } from "components/DropdownSelect";
import { ModalCustom } from "components/ModalCustom";
import { Required } from "components/Required";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import {
  CaixaCampos,
  ContainerBotoes,
  TextoDescricao,
} from "../../../SolicitacaoPlaca/modals/SolicitarAutorizacaoModal/style";
import { codigoOuNulo } from "../../../SolicitacaoPlaca/utils/codigoOuNulo";
import { useFornecedoresTerceiros } from "../../hooks/useFornecedoresTerceiros";
import { IDadosEnvioTerceiros } from "../../interfaces/IFornecedorTerceiros";
import { emailInvalido } from "../../utils/emailsEnvio";
import { CampoEmails } from "./CampoEmails";
import { QuadroSelecionados } from "./style";

interface IProps {
  show: boolean;
  quantidade: number;
  carregando: boolean;
  handleClose: () => void;
  onConfirmar: (dados: IDadosEnvioTerceiros) => void;
}

export function EnviarSolicitacaoModal({
  show,
  quantidade,
  carregando,
  handleClose,
  onConfirmar,
}: IProps) {
  const { fornecedores, carregando: carregandoFornecedores } =
    useFornecedoresTerceiros();
  const [idFornecedor, setIdFornecedor] = useState<number | null>(null);
  const [emails, setEmails] = useState<string[]>([]);
  const opcoesFornecedor = useMemo(
    () => fornecedores.map(({ id, nome }) => ({ value: id, label: nome })),
    [fornecedores]
  );

  useEffect(() => {
    if (!show) return;
    setIdFornecedor(null);
    setEmails([]);
  }, [show]);

  const selecionarFornecedor = useCallback(
    (valor: string | number | null) => {
      const id = codigoOuNulo(valor);

      setIdFornecedor(id);
      setEmails([
        ...(fornecedores.find((fornecedor) => fornecedor.id === id)?.emails ??
          []),
      ]);
    },
    [fornecedores]
  );

  function confirmar() {
    if (idFornecedor) onConfirmar({ idFornecedor, emails });
  }

  const fecharSeLivre = carregando ? () => {} : handleClose;

  return (
    <ModalCustom
      show={show}
      handleClose={fecharSeLivre}
      title="Enviar solicitação"
      centered
      footer
      footerTools={
        <ContainerBotoes>
          <PrimaryButton
            type="button"
            outline
            variante="primary"
            onClick={fecharSeLivre}
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            type="button"
            onClick={confirmar}
            disabled={
              carregando ||
              !idFornecedor ||
              !emails.length ||
              emails.some(emailInvalido)
            }
          >
            Enviar
          </PrimaryButton>
        </ContainerBotoes>
      }
    >
      <TextoDescricao>
        Preencha as informações abaixo para enviar a solicitação.
      </TextoDescricao>
      <QuadroSelecionados>
        <span>Processos selecionados</span>
        <strong>{String(quantidade).padStart(2, "0")}</strong>
      </QuadroSelecionados>
      <CaixaCampos>
        <Form.Group>
          <Form.Label>
            Fornecedor <Required />
          </Form.Label>
          <DropdownSelect
            options={opcoesFornecedor}
            selectedValue={idFornecedor}
            onSelect={selecionarFornecedor}
            loading={carregandoFornecedores}
            searchable
          />
        </Form.Group>
        {idFornecedor && (
          <Form.Group>
            <Form.Label>
              E-mail <Required />
            </Form.Label>
            <CampoEmails emails={emails} onChange={setEmails} />
          </Form.Group>
        )}
      </CaixaCampos>
    </ModalCustom>
  );
}
